<template>
  <div class="router-transitions">
    <div class="container">
      <TitleCustom v-if="$cookie.get('language') == 'fr'" blackTitle="Mentions" blueTitle="Légales"></TitleCustom>
      <TitleCustom v-else blackTitle="Legal" blueTitle="Notice"></TitleCustom>
      <b-card v-if="$cookie.get('language') == 'fr'">
        <p>Ce site internet appartient à Groupe Obea</p>
    
        <h1>Informations relatives au propriétaire du site internet</h1>
        <p>
          Groupe Obea<br/>
          Adresse : 26, rue Vauquelin – 75005 Paris<br/>
          Tél : 01.40.53.71.10<br/>
          Mail :  contact.mh@obea.fr <br/>
        </p>
    
        <h1>Hébergement du site</h1>
        <p>
          OVH
          Code APE : 2620Z
          Adresse : 2 rue Kellermann – 59100 Roubaix – France
          Site : www.ovh.com
        </p>
    
    
        <h1>Réalisation du site</h1>
        <p>
          Groupe Obea
          Adresse : 26, rue Vauquelin – 75 005 Paris
        </p>
    
        <h1>Mentions légales</h1>
        <p>
          La loi française du 11 mars 1957 n’autorise, aux termes des alinéas 2 et 3 de l’article 41, d’une part, que les « copies ou reproductions strictement réservées à l’usage privé du copiste et
          non destinées à une utilisation collective » et, d’autre part, que les analyses et les courtes citations dans un but d’exemple et d’illustration (« toute représentation ou reproduction intégrale, ou partielle,
          faîtes sans le consentement de l’auteur ou de ses ayants droit ou ayants cause, est illicite » – alinéa 1er de l’article 40). Toute représentation ou reproduction abusive du site  https://mh.obea-ecoute-engagement.fr,
          par quelque procédure que ce soit, constituerait donc une contrefaçon sanctionnée par les articles 425 et suivants du Code pénal.
          Tout le contenu du site, les graphismes, images, textes, logos ainsi que leur mise en forme sont la propriété exclusive de Groupe Obea à l’exception des marques, logos ou contenus appartenant
          à d’autres sociétés partenaires.
          Dans tous les cas, ces textes originaux ne peuvent être cités qu’à condition de prévenir l’auteur.<br/>
          Les liens présents sur ce site peuvent orienter l’utilisateur sur des sites extérieurs dont le contenu ne peut en aucune manière engager la responsabilité de la rédaction du site.
          Enfin, toutes les photos exposées sur le site appartiennent à leur auteur respectif, tout comme le contenu qui a été spécialement conçu pour le site.
        </p>
        <b-btn variant="default"  @click="$router.go(-1)">{{ $t('back') }}</b-btn>
  
      </b-card>
      <b-card v-else>
        <p>This website belongs to Obea Group</p>
        <h1>Information regarding the owner of the website</h1>
        <p>
          Groupe Obea<br/>
          Address : 26, rue Vauquelin – 75005 Paris<br/>
          Tél : 01.40.53.71.10<br/>
          Mail : contact.mh@obea.fr<br/>
          Website hosting<br/>
          OVH APE code: 2620Z Address: 2 rue Kellermann - 59100 Roubaix - France Site: www.ovh.com<br/>
        </p>
        <h1>Website creation</h1>
        <p>
          Groupe Obea
          Address : 26, rue Vauquelin – 75005 Paris
        </p>
        <h1>Legal Notice</h1>
        <p>The French law of March 11, 1957 authorizes, under the terms of paragraphs 2 and 3 of article 41, on the one hand, only “copies or reproductions strictly reserved for the
        private use of the copyist and not intended for a collective use” and, on the other hand, only the analysis and short quotations for the purpose of example and illustration
        (“ any representation or reproduction, in whole or in part, made without the consent of the author or his assigns or successors in title, is illegal ”- paragraph 1 of article 40).
        Any improper representation or reproduction of the https://mh.obea-ecoute-engagement.fr,  site, by any procedure whatsoever, would therefore constitute an infringement punishable
        by articles 425 and following of the French Penal Code. All site content, graphics, images, texts, logos and their formatting are the exclusive property of Groupe Obea with the exception
        of brands, logos or content belonging to other partner companies. In all cases, these original texts can only be cited if the author is notified and formally agree.<br/>
        The links on this site can direct the user towards external websites whose content cannot in any way engage the responsibility of the website’s redactors. Finally, all the
          photos displayed on the website belong to their respective authors, as does the content that has been specially designed for the site.</p>

      </b-card>
    </div>
    
  </div>
</template>
<style>
  h1 {
    text-align:left;
  }
</style>
<script>
  import TitleCustom from '../components/title'
  export default {
    name: 'Confidentialite',
    components: { TitleCustom, },
    mounted() {
      if (this.$cookie.get('language') === 'fr' || this.$cookie.get('language') === 'en'){
        this.$i18n.locale = this.$cookie.get('language')
      } else {
        this.$cookie.set('language', 'fr', 300);
        location.reload();
      }
    
    },

  }
</script>
